import * as React from "react"
import { backDismissal } from "./back-dismiss.ts"

/**
 * While `open`, the browser's Back (iOS's swipe from the edge, Android's Back) calls `close` and
 * leaves the page where it was, rather than leaving the page. Give it an overlay's open state on
 * `compact` only, where an overlay is a sheet or an alert: the Drawer gives it every drawer's, a
 * docked Menu or Select its own, and an AlertDialog its own. How the history entry behaves: `back-dismiss.ts`.
 *
 * Back takes the sheet's entry whether or not the sheet closes. One whose caller keeps it open (New
 * group while it saves) gets a fresh entry, so the next Back still finds the sheet rather than
 * leaving the page under it.
 */
export function useBackDismiss(open: boolean, close: () => void) {
  const [backs, setBacks] = React.useState(0)
  const onBack = React.useEffectEvent(() => {
    setBacks((count) => count + 1)
    close()
  })
  React.useEffect(() => {
    if (!open) return
    return backDismissal()(() => onBack())
  }, [open, backs])
}
